import { ToolPageShell } from '@/shared/seo'
import { PngVPdfForm } from './PngVPdfForm'

export function PngVPdfPage() {
  return (
    <ToolPageShell utilityKey="png-v-pdf">
      <PngVPdfForm />
    </ToolPageShell>
  )
}
